import { SYNCTIMESv1 } from './SYNCTIMESv1';
import { MAINv3 } from './MAINv3';

import { TDatabase } from './database.model';

const DATABASES: TDatabase[] = [SYNCTIMESv1, MAINv3];

export default DATABASES;
